import { cn } from '@/lib/utils';
import { TimeOffTypeCode } from '@/modules/common/types/time-off-type';
import { ScrollableText } from '@/modules/planner/components/assignment/text/scrollable-text';

import { getTimeOffTypeIcon } from '../../../constants/time-off-type-icon-map';

interface TimeOffTypeCellProps {
  code: TimeOffTypeCode | null;
  displayName: string;
  isPast: boolean;
}

export const TimeOffTypeCell = ({ code, displayName, isPast }: TimeOffTypeCellProps) => {
  const Icon = getTimeOffTypeIcon(code ?? TimeOffTypeCode.PAID_VACATION);

  return (
    <div className={cn('flex min-w-0 items-center gap-2', isPast && 'opacity-50')}>
      <Icon className="h-4 w-4 shrink-0 text-muted-foreground" />
      <div className="min-w-0 flex-1 overflow-hidden">
        <ScrollableText className="whitespace-nowrap">{displayName}</ScrollableText>
      </div>
    </div>
  );
};
